import FormGroupElement from "./FormGroupElement";
import React from "react";

export default class Info extends FormGroupElement {

    render() {
        let props: any = {...this.props};

        props.role = props?.role || 'alert';
        props.className = (props?.className ? props.className + ' ' : '') + 'alert alert-primary';

        return (
            <div {...props}>
                <i className="bi bi-info-circle-fill color-blue"></i>
                {this.props.children}
            </div>
        );
    }
}
